<template>
  <div>
    <Header title="学生评价详情"></Header>

    <div class="pjItem">
      <div class="list">
        <div
          class="list-item info"
          v-for="(item, index) of optionList"
          :key="index"
        >
          <p>{{ item.pjzbmc }}</p>

          <van-radio-group v-model="item.radio" disabled>
            <van-radio
              :name="index1"
              v-for="(item1, index1) of item.lstpj0601"
              :key="index1"
            >
              {{ String.fromCharCode(index1 + 65) }}.<span
                v-html="item1.mc"
              ></span>
            </van-radio>
          </van-radio-group>
        </div>
        <span v-if="advice">
          <div
            class="list-item info"
            v-for="(item, index) of advice"
            :key="index"
          >
            <p>{{ item.jymc }}</p>
            <ul>
              <li>
                {{ item.pj0902.jynr }}
              </li>
            </ul>
          </div>
        </span>
        <div class="list-item info" v-if="teacher">
          <p>教师回复</p>
          <ul>
            <li>
              {{ teacher.jyhfnr == "" ? "无" : teacher.jyhfnr }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      optionList: [],
      advice: false,
      teacher: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    dealOption() {
      for (let i of this.optionList) {
        let radio = 0;
        for (let j = 0; j < i.lstpj0601.length; j++) {
          if (i.lstpj0601[j].ischecked == "1") {
            radio = j;
            continue;
          }
        }
        i.radio = Number(radio);
      }
    },
    async getList() {
      const res = await Api.xspj_conf({
        xnxq01id: this.$route.query.list.xnxq01id,
        pjrid: this.$route.query.list.pjrid,
        pj01id: this.$route.query.list.pj01id,
        jx02id: this.$route.query.list.jx02id,
        pj0502id: this.$route.query.list.pj0502id,
        jg0101id: this.$route.query.list.jg0101id,
        jx0404id: this.$route.query.list.jx0404id,
        zpf: this.$route.query.list.zpf
      });

      if (res.code == "0") {
        setTimeout(() => {
          this.$router.replace("/evaluateSum/index");
        }, 3000);
        return;
      }
      this.optionList = res.lstPj06;
      if (res.lstPj03.length < 0) {
        return;
      }
      this.advice = res.lstPj03;
      this.advice.forEach(item => {
        if (this.advice && JSON.stringify(item.pj0902) != "{}") {
          this.teacher = item.pj0902;
        }
      });

      this.dealOption();
    }
  }
};
</script>
<style lang="less">
.pjItem {
  padding: 0 20px;
  .list-item {
    background: #f8f8f8;
    border-radius: 5px;
    margin: 0 auto 5%;
    padding: 3% 0 3% 6%;
    position: relative;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      margin-bottom: 2%;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #757da3;
      letter-spacing: 0;
      margin-bottom: 1%;
    }
  }
}
</style>
<style lang="less">
.van-radio {
  margin-bottom: 10px;
}
.van-radio__icon--checked .van-icon {
  background-color: #1989fa;
  border-color: #1989fa;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/evaluateSum/item.vue